module.exports = __webpack_public_path__ + "media/images/ic_women-8f7b4df6.svg";